module.exports = __webpack_public_path__ + "img/camera.f8f8ca77.svg";